import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20warm%20abstract%20background%20with%20flowing%20ink%20and%20watercolor%20textures%20in%20rose%20gold%20and%20cream%20tones%2C%20elegant%20artistic%20brush%20strokes%2C%20dreamy%20literary%20atmosphere%2C%20subtle%20paper%20texture%2C%20no%20text%2C%20no%20typography%2C%20pure%20abstract%20art&width=1600&height=900&seq=hero-bg-wenai&orientation=landscape"
          alt="文爱社区 - 文字情感交流平台背景"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 animate-fade-in-down tracking-wide">
          在文字中遇见温暖
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed animate-fade-in-up">
          文爱社区 —— 专注于文字情感表达与互动的高品质社区平台。<br className="hidden sm:block" />
          汇聚热爱文字交流的用户，分享心声、寻找共鸣，体验文字带来的温度与浪漫。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up">
          <Link
            to="/about"
            className="px-8 py-3 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即加入文爱社区
          </Link>
          <Link
            to="/category/qinggan-duben"
            className="px-8 py-3 rounded-full border border-white/30 text-white text-sm font-medium hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            探索精彩内容
          </Link>
        </div>
        <div className="mt-10 flex items-center justify-center gap-8 animate-fade-in-up">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">50万+</p>
            <p className="text-xs text-white/60 mt-1">注册用户</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">100万+</p>
            <p className="text-xs text-white/60 mt-1">原创文章</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">500万+</p>
            <p className="text-xs text-white/60 mt-1">互动评论</p>
          </div>
        </div>
      </div>
    </section>
  );
}